export const NET30 = 'net30'
export const NET45 = 'net45'

export const PAYMENT_TERMS = {
  [NET30]: 'Net30',
  [NET45]: 'Net45'
}
